import useJwt from '@core/auth/jwt/useJwt'
import axios from '@axios'
import productuinConfigs from './jwtProductionConfig'

const { jwt } = useJwt(axios, productuinConfigs)
export default jwt
